module.exports = __webpack_public_path__ + "img/金莲花.9584b246.jpg";